import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, NumericTextBox, Checkbox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Error } from "@progress/kendo-react-labels";
import areas from "./Areas.json";
import { Upload } from "@progress/kendo-react-upload";
import { useGlobalState } from '../../App.js';

export const NewForm = props => {
    const [loginInfo, updateLoginInfo] = useGlobalState();

    const onBeforeUpload = (event) => {
        console.log('onBeforeUpload');
        console.log('headers: ' + JSON.stringify(event.headers));
        event.headers = {
            'Authorization': 'Bearer ' + loginInfo.token
        }
        //'accept': 'application/json', 'Content-Type': 'application/json',
    }

    const onBeforeRemove = (event) => {
        console.log('onBeforeRemove');
    }

  

    return <Dialog title={`New Message `} onClose={props.cancelNew}>
        <Form onSubmit={props.onSubmit} initialValues={props.item} render={formRenderProps => <FormElement style={{
            maxWidth: 650
        }}>
            <fieldset className={"k-form-fieldset"}>
                <div className="mb-3">
                    <Field
                        name={"messageName"}
                        id={"messageName"}
                        component={Input}
                        label={"Name"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"area"}
                        id={"area"}
                        component={DropDownList}
                        data={areas}
                        dataItemKey={"id"}
                        textField={"areaName"}
                        label={"Areas"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"messageId"}
                        id={"messageId"}
                        component={NumericTextBox}

                        label={"Message Id Number"}
                    />
                </div>
                <div className="mb-3">
                    <Upload
                        batch={false}
                        multiple={false}
                        defaultFiles={[]}
                        onBeforeUpload={onBeforeUpload}
                        onBeforeRemove={onBeforeRemove}
                        onStatusChange={(event) => {
                            console.log('onStatusChange2 ' + JSON.stringify(event.newState));
                            if (event.newState[0].status == 4) {
                                console.log("successfully uploaded. File is: " + event.newState[0].name);
                                formRenderProps.onChange("messageWav", {
                                    value: event.newState[0].name,
                                });
                            }
                        }}
                        withCredentials={true}
                        saveUrl={"/api/uploads"}
                        removeUrl={"/api/uploads"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"messageWav"}
                        id={"messageWav"}
                        component={Input}
                        readOnly={true }
                        label={"File"}
                    />
                </div>
                <div className="mb-3">
                    <Field
                        name={"messageActive"}
                        id={"messageActive"}
                        component={Checkbox}
                        label={"Active"}
                    />
                </div>
                <div className="mb-3">
                    <p></p>
                </div>
            </fieldset>
            <div className="k-form-buttons">
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" disabled={!formRenderProps.allowSubmit}>
                    Update
                </button>
                <button type={"submit"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={props.cancelNew}>
                    Cancel
                </button>
            </div>
        </FormElement>} />
    </Dialog>;
}; 